import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderSolid from '../../sections/header/HeaderSolid'

import './style.scss'
import CtaButton from '../../components/ctaButton/CtaButton'
import { useEffect, useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { registerConnector } from '../../server/connector/registerConnector'
import LabeledSelectMenu from '../../components/labeledSelectMenu/LabeledSelectMenu';
import LabeledCheckbox from '../../components/labeledCheckbox/LabeledCheckbox'
import { useAppSelector } from '../../redux/hooks'
import { userStateData } from '../../data/userStateData'

function SignUpCustomer() {

	const [signingUp, setSigningUp] = useState<boolean>(false)
	const [signUpFailed, setSignUpFailed] = useState<boolean>(false)

	const [firstName, setFirstName] = useState<string>('')
	// const [lastName, setLastName] = useState<string>('')
	const [email, setEmail] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const [confirmPassword, setConfirmPassword] = useState<string>('')
	const [phone, setPhone] = useState<string>('')

	const [dobDate, setDobDate] = useState<string>('01')
	const [dobMonth, setDobMonth] = useState<string>('01')
	const [dobYear, setDobYear] = useState<string>('1980')

	const [termsOfServiceAccepted, setTermsOfServiceAccepted] = useState<boolean>(false)

	const [signUpSuccess, setSignUpSuccess] = useState<boolean>(false)

	const [passwordContainsSpecialChars, setPasswordContainsSpecialChars] = useState<boolean>(false)
	const [passwordContainsDigit, setPasswordContainsDigit] = useState<boolean>(false)
	const [passwordLongEnough, setPasswordLongEnough] = useState<boolean>(false)

	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)

	const specialChars = `\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`
	const numberChars = '0123456789'

	useEffect(() => {
		// check if log in has been checked and confirmed in App.tsx
		if (loginChecked == true) {
			// confirm a user is logged in
			if (userStateData.loggedIn == true) {
				// TEMP: redirect to dashboard if user has already logged in
				window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
			} 
		}
	}, [loginChecked])

	const signUpClicked = () => {
		setSigningUp(true)
		// registerConnector.performRegisterRequest(firstName, email, password, phone, '2000-01-01').then((successRequest) => {
		registerConnector.performRegisterRequest(firstName, email, password, phone, `${dobYear}-${dobMonth}-${dobDate}`).then((successRequest) => {
			if (!successRequest) {
				setSignUpFailed(true)
				setSigningUp(false)
			} else {
				// window.location.replace(PAGE_URLS.THANK_YOU)
				// TEMP: redirect to log in for new customer who doesn't need to wait for email
				window.location.replace(PAGE_URLS.LOG_IN)
				setSignUpSuccess(true)
				setSigningUp(false)
			}
		})
	}

	const dobDateChangeHandler = (newValue: string) => {
		setDobDate(newValue)
	}

	const dobMonthChangeHandler = (newValue: string) => {
		setDobMonth(newValue)
	}

	const dobYearChangeHandler = (newValue: string) => {
		setDobYear(newValue)
	}

	const passwordChangeHandler = (newValue: string) => {
		let containsSpecialChar: boolean = false
		specialChars.split('').forEach((char: string) => {
			if (newValue.includes(char)) {
				containsSpecialChar = true
			}
		})
		setPasswordContainsSpecialChars(containsSpecialChar)
		let containsNumber: boolean = false
		numberChars.split('').forEach((char: string) => {
			if (newValue.includes(char)) {
				containsNumber = true
			}
		})
		setPasswordContainsDigit(containsNumber)
		setPasswordLongEnough(newValue.length > 7)
		setPassword(newValue)
	}
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<HeaderSolid />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<div className='sign-up-content'>
						<div className='sign-up-content-section'>
							<div className='sign-up-form'>
								<div className='sign-up-form-title'>Customer Sign Up</div>
								{signUpSuccess ? 
									<div className='sign-up-form-label-txt'>
										Sign Up Complete, Please verify your email using the link sent to your email
									</div>
									:
									<>
										<input 
											className='sign-up-form-input' 
											placeholder={'Full Name *'} 
											value={firstName}
											onChange={(event) => {
												setFirstName(event.target.value)
											}}
											disabled={signingUp}
										/>
										{/* <input 
											className='sign-up-form-input' 
											placeholder={'Last Name *'} 
											value={lastName}
											onChange={(event) => {
												setLastName(event.target.value)
											}}
										/> */}
										<div className='sign-up-form-label-txt'>
											Date of birth
										</div>
										<div
											className='sign-up-form-dob-wrap'
										>
											<LabeledSelectMenu
												label='Date'
												// options={Array.from({length: 31}, (_, i) => `${i + 1}`)}
												options={Array.from({length: 31}, (_, i) => `${i + 1 < 10 ? `0${i + 1}` : i + 1}`)}
												onChange={dobDateChangeHandler}
												value={dobDate}
											/>
											<LabeledSelectMenu
												label='Month'
												options={Array.from({length: 12}, (_, i) => `${i + 1 < 10 ? `0${i + 1}` : i + 1}`)}
												onChange={dobMonthChangeHandler}
												value={dobMonth}
											/>
											<LabeledSelectMenu
												label='Year'
												options={Array.from({length: 50}, (_, i) => `${i + 2025 - 15 - 50}`)}
												onChange={dobYearChangeHandler}
												value={dobYear}
											/>
										</div>
										<input 
											className='sign-up-form-input' 
											type={'email'} 
											placeholder={'Email Address *'} 
											value={email}
											onChange={(event) => {
												setEmail(event.target.value)
											}}
											disabled={signingUp}
										/>
										<input 
											className='sign-up-form-input' 
											placeholder={'Phone Number (Optional)'} 
											value={phone}
											onChange={(event) => {
												setPhone(event.target.value)
											}}
											disabled={signingUp}
										/>
										<input 
											// className='sign-up-form-input' 
											className={`${(passwordContainsSpecialChars === false || passwordContainsDigit === false || passwordLongEnough === false) && password.length > 0 ? 'sign-up-form-input sign-up-form-input-red' : 'sign-up-form-input'}`}
											placeholder={'Password *'} 
											value={password}
											onChange={(event) => {
												passwordChangeHandler(event.target.value)
											}}
											type='password'
											disabled={signingUp}
										/>
										{passwordContainsSpecialChars === false && <div className='sign-up-form-requirement-txt'>Must contain special character</div>}
										{passwordContainsDigit === false && <div className='sign-up-form-requirement-txt'>Must contain a digit</div>}
										{passwordLongEnough === false && <div className='sign-up-form-requirement-txt'>Must be at least 8 characters long</div>}
										<input 
											className='sign-up-form-input' 
											placeholder={'Confirm Password *'} 
											value={confirmPassword}
											onChange={(event) => {
												setConfirmPassword(event.target.value)
											}}
											type='password'
											disabled={signingUp}
										/>
										<LabeledCheckbox
											label={`I agree to the <a href='${PAGE_URLS.TERMS_AND_CONDITIONS}' target='_blank'>Terms of Service Agreement</a>`}
											onChange={(newValue:boolean) => {
												setTermsOfServiceAccepted(newValue)
											}}
											isOn={termsOfServiceAccepted}
											disabled={signingUp}
										/>
										{signUpFailed && <div className='sign-up-form-signup-failed'>
											Sign Up Failed, account may already exist, please try to log in
										</div>}
										<CtaButton
											label='Sign Up'
											size='medium'
											onClick={() => signUpClicked()}
											fullWidth={true}
											disabled={
												firstName === '' || 
												// lastName === '' || 
												// phone === '' || 
												email === '' ||
												password === '' ||
												confirmPassword === '' ||
												password !== confirmPassword ||
												signingUp === true ||
												termsOfServiceAccepted === false ||
												passwordContainsSpecialChars === false ||
												passwordContainsDigit === false ||
												passwordLongEnough === false
											}
										/>
										<div className='line-text-span-wrap'>
											<div className='line-text-span-wrap-span'>or</div>
										</div>
										<div className='sign-already-have-account'>Already have an account? <a href={PAGE_URLS.LOG_IN}>Sign in</a></div>
									</>
								}
							</div>
						</div>
						<div className='sign-up-content-section sign-up-picture-section'>
							<img
								className='sign-up-picture'
								alt='Ski Lift'
								src='/imgs/pictures/ski-lift.png'
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default SignUpCustomer
